import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AvtaleService } from 'src/app/services/avtale/avtale.service';
import { Avtaler } from 'src/app/services/avtale/avtale.types';
import { EnodeService } from 'src/app/services/enode/enode.service';
import {
  LocationSuggestion,
  UserLocation
} from 'src/app/services/enode/enode.types';

@Component({
  selector: 'app-charging-location',
  templateUrl: './charging-location.component.html',
  styleUrls: ['./charging-location.component.scss']
})
export class ChargingLocationComponent {
  @Input() isSetup = false;
  @Input() isModal = false;

  showMap = false;
  locationSuggestions: LocationSuggestion[];
  chosenLocation: LocationSuggestion;
  locationChosen = false;
  locationName: string;
  hasPostLocationError = false;
  noLocationFound = false;
  hasPostTariffError = false;

  friendlyLocationName: string;

  locationId: string;

  avtaler: Avtaler[];
  chosenAvtale: Avtaler;
  objectId: string;
  avtaleError = false;
  smartChargePolicyErrorMessage: string;

  noLocationChosen = false;

  // Set denne basert på om lokasjonen har en objectId eller ikke
  chosenLocationObjectId = false;
  userLocation: UserLocation;

  subscription: Subscription;

  @Output() emitProgressSetup = new EventEmitter<boolean>();
  @Output() emitCancelSetup = new EventEmitter<boolean>();
  @Output() emitLocationName = new EventEmitter<string>();
  @Output() emitLocation = new EventEmitter<UserLocation>();
  constructor(
    private _enodeService: EnodeService,
    private _avtaleService: AvtaleService
  ) {}

  ionViewWillLeave() {
    this.subscription?.unsubscribe();
  }

  ngOnInit() {
    this.subscription = this._avtaleService.getAvtaler(new Date()).subscribe({
      next: (res) => {
        this.avtaler = res.avtaler;
        // Velg avtalen med høyeste forbruk
        this.chosenAvtale = this.avtaler.reduce((prev, current) =>
          prev.aarsforbruk > current.aarsforbruk ? prev : current
        );
      }
    });

    this.hasPostLocationError = false;
    this._enodeService.getLocationSuggestions().subscribe({
      next: (locations) => {
        this.locationSuggestions = locations.filter(
          (location) =>
            location.domain === 'accounting_point' &&
            location.latitude &&
            location.longitude
        );
        if (this.locationSuggestions.length === 0) {
          locations.forEach((location) => {
            // Lokasjon fra adressene knyttet til brukeren
            if (location?.adresse && location?.postnr && location?.poststed) {
              const address = `${location?.adresse} ${location?.postnr} ${location?.poststed}`;
              new google.maps.Geocoder()
                .geocode({
                  address: address
                })
                .then((results) => {
                  const result = results.results[0];

                  if (!result.types.includes('route')) {
                    this.locationSuggestions.push({
                      ...location,
                      latitude: result.geometry.location.lat(),
                      longitude: result.geometry.location.lng()
                    });
                  }
                });
            } else if (location.latitude && location.longitude) {
              new google.maps.Geocoder()
                .geocode({
                  location: {
                    lat: location.latitude,
                    lng: location.longitude
                  }
                })
                .then((results) => {
                  const result = results.results[0];
                  this.locationSuggestions.push({
                    ...location,
                    name:
                      result.formatted_address.split(',')[0] +
                      '\n(' +
                      location.name +
                      ')',
                    latitude: result.geometry.location.lat(),
                    longitude: result.geometry.location.lng()
                  });
                });
            }
          });
        }
      },
      error: () => {
        this.noLocationFound = true;
      }
    });
  }

  pickLocation(location: LocationSuggestion) {
    this.chosenLocation = location;
    if (this.chosenLocation?.domain === 'accounting_point') {
      this.chosenLocationObjectId = true;
      // set objectID based on selected location
      this.objectId = this.chosenLocation.identification;
      this.friendlyLocationName = this.chosenLocation.name;
    } else {
      this.chosenLocationObjectId = false;
      this.objectId = this.chosenAvtale.objectid;
      this.friendlyLocationName = this.chosenLocation.name
        .split('(')[0]
        .split(')')[0];
    }
    this.locationChosen = true;
  }

  setSelectedLocation(location: google.maps.places.PlaceResult) {
    const locationFromMap = {
      latitude: location.geometry.location.lat(),
      longitude: location.geometry.location.lng(),
      name:
        location.formatted_address.split(',')[0] ?? location.formatted_address
    } as LocationSuggestion;

    this.locationSuggestions.push(locationFromMap);

    this.showMap = false;
    this.noLocationFound = false;
    this.chosenLocation = locationFromMap;
    this.locationChosen = true;
    this.friendlyLocationName = this.chosenLocation.name;
  }

  openMap() {
    this.showMap = true;
  }

  setLocation() {
    this.noLocationChosen = false;
    if (this.chosenLocation === undefined) {
      this.noLocationChosen = true;
    }
  }

  back() {
    this.emitCancelSetup.emit(true);
  }

  postLocation() {
    this.hasPostLocationError = false;
    this.hasPostTariffError = false;
    this._enodeService
      .setLocation(this.locationName ?? this.chosenLocation.name, {
        lat: this.chosenLocation.latitude,
        lng: this.chosenLocation.longitude
      })
      .subscribe({
        next: (res) => {
          this.userLocation = res;
          this.locationId = res.id;

          this._enodeService
            .postTariffConfig(this.objectId, this.locationId)
            .subscribe({
              next: (res) => {
                if (this.isSetup) {
                  this.emitLocationName.emit(this.locationName);
                  this.emitProgressSetup.emit(true);
                }
                if (this.isModal) {
                  this.emitLocation.emit(this.userLocation);
                }
              },
              error: (err) => {
                this.hasPostTariffError = true;
              }
            });
          if (this.isSetup) {
            this.emitLocationName.emit(this.locationName);
            this.emitProgressSetup.emit(true);
          }
          if (this.isModal) {
            this.emitLocation.emit(this.userLocation);
          }
        },
        error: () => {
          this.hasPostLocationError = true;
        }
      });
  }
}
